



























































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import Confirm from '@/modules/common/dialog/components/shared/Confirm.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import { Emit, Prop, PropSync } from 'vue-property-decorator'

enum AlertTypes {
  WARNING = 'warning',
  SUCCESS = 'success',
  INFO = 'info',
}

@Component({
  components: { BaseButton, Confirm }
})
export default class WarningConfirm extends Vue {
  @Prop() submitUrl !: string
  @Prop({ default: 'حذف' }) submitText !: string
  @Prop({ default: 'انصراف' }) cancelText !: string
  @Prop({ default: 'ion alert-circle' }) icon !: string
  @Prop({ default: 'حذف اطلاعات' }) title !: string
  @Prop({ default: 'get' }) method !: string
  @Prop() message !: string
  @Prop({ default: AlertTypes.WARNING }) AlertType: AlertTypes

  @PropSync('closeTicket',
    { default: false }
  ) confirm!: boolean

  get color() {
    switch (this.AlertType) {
      case AlertTypes.INFO:
        return 'tes-blue'
      case AlertTypes.SUCCESS:
        return 'tes-green'
    }

    return 'tes-gradient-orange'
  }

  @Emit()
  agreeConfirm() {
  }

}
